import { Box, Typography } from "@mui/material";
import { ResolvedColors } from "../colorResolver";
import { HomePreview } from "./HomePreview";

interface INavigationPreviewProps {
  colors: ResolvedColors;
  images: {
    menu_background?: string;
    menu_logo?: string;
    home_background?: string;
    home_logo?: string;
    placeholder?: string;
  };
}

const MAIN_ITEMS = ["News", "Lineup", "Showcase", "Clashfinder", "Map", "Sponsors", "Food", "Info"];
const MORE_ITEMS = ["Settings", "Notifications", "Reminders"];

// The drawer only covers part of the screen width - the underlying screen
// (Home, in this preview) stays visible down the right edge, matching the app.
const DRAWER_WIDTH = "84%";

export const NavigationPreview = ({ colors, images }: INavigationPreviewProps) => {
  return (
    <Box sx={{ position: "relative", width: "100%", height: "100%", overflow: "hidden" }}>
      <Box sx={{ position: "absolute", inset: 0 }}>
        <HomePreview
          colors={colors}
          images={{
            home_background: images.home_background,
            home_logo: images.home_logo,
            placeholder: images.placeholder,
          }}
        />
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          width: DRAWER_WIDTH,
          backgroundColor: colors.primaryColorDarker,
          backgroundImage: images.menu_background ? `url(${images.menu_background})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
          boxShadow: "6px 0 16px rgba(0,0,0,0.45)",
          overflow: "auto",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
          {images.menu_logo ? (
            <Box
              component="img"
              src={images.menu_logo}
              sx={{ width: 130, height: 95, objectFit: "contain" }}
            />
          ) : (
            <Typography variant="caption" sx={{ color: colors.primaryColorText, opacity: 0.6 }}>
              LOGO
            </Typography>
          )}
        </Box>

        <Box sx={{ mx: 1, backgroundColor: colors.navigationMenuItemBackgroundColor }}>
          {MAIN_ITEMS.map((item) => (
            <NavItem key={item} label={item} color={colors.primaryColorText} />
          ))}

          <Typography
            variant="caption"
            sx={{
              display: "block",
              color: colors.primaryColorText,
              opacity: 0.6,
              px: 2,
              pt: 1.5,
              pb: 0.5,
              letterSpacing: 1,
            }}
          >
            MORE
          </Typography>
          {MORE_ITEMS.map((item) => (
            <NavItem key={item} label={item} color={colors.primaryColorText} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

const NavItem = ({ label, color }: { label: string; color: string }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, height: 40, px: 2 }}>
    <Box
      sx={{
        width: 20,
        height: 20,
        borderRadius: "50%",
        border: `1.5px solid ${color}`,
        opacity: 0.8,
        flexShrink: 0,
      }}
    />
    <Typography variant="body2" sx={{ color }}>
      {label}
    </Typography>
  </Box>
);
